import axios from '../../common/axios.js'
import CryptoJS from 'crypto-js'
import Input from '../../common/forms/Input.vue'
import LoadingBtn from '../../common/ui/loading_btn.vue'

export default {
	data(){
		return {
			passwordTypeA: 'password',
			passwordA: '',
			passwordTypeB: 'password',
			passwordB: '',
			error: false,
			expired: false,
			message_erreur: 'connection_erreur',
			loading: false,
			success: false
		}
	},
	created(){
		let params =  this.$store.state.ui.modal_params;
		let timestamp = new Date(params.token.exp).getTime();
		if(params.token.exp && timestamp < Date.now()){
			this.error = true;
			this.expired = true;
			this.message_erreur = 'modal_recupass_token_expired';
		}
	},
	methods:{
		switchInput(field){
			this[`passwordType${field}`] = this[`passwordType${field}`] == 'password' ? 'text' : 'password'
		},
		change_password(){
			if(this.passwordA != this.passwordB){
				this.error = true;
				this.message_erreur = 'modal_recupass_password_different';
				return;
			}

			this.loading = true;
			axios.post('/plugin_projet/plugin_projet_iannuaire/change_password', {
				password: this.passwordA,
				password_confirm: this.passwordB,
				token: this.$store.state.ui.modal_params.t
			}).then((response) => {
				this.loading = false;
				if(response.data.success){
					this.success = true;
				} else {
					this.error = true;
					this.message_erreur = /_/.test(response.data.message) ? 'modal_recupass_' + response.data.message : response.data.message;
					if(response.data.message == 'token_expired'){
						this.expired = true;
					}
				}
			}).catch((error) => {
				this.loading = false;
				this.error = true;
				this.message_erreur = 'modal_recupass_error';
			})
		},
		go_to_connection(){
			history.pushState({}, '', window.location.pathname);
			this.$store.commit('UI_SET_MODAL', { modal: 'connection' });
		},
		go_to_recupass(){
			history.pushState({}, '', window.location.pathname);
			this.$store.commit('UI_SET_MODAL', { modal: 'password' });			
		}		
	},
	components: {
		Input,
		LoadingBtn
	}
}
